import Transform from '@ember-data/serializer/transform';

/**
 * Currently the server is returning URLs that are already Thumbor-encoded
 * (i.e. "https://thumborendpoint=/https://imagehost/file.jpg"), which creates
 * problems if and when we need to do our own Thumbor encoding. This
 * `RegExp` returns the last URL from strings like this, or nothing if
 * the string doesn't match.
 */

const MULTIPLE_URL_REGEX = /^https?:.+\/(https?:.+)$/;
function deserializeItemImageUrl(url) {
  if (!url) {
    return undefined;
  }
  const matches = url.match(MULTIPLE_URL_REGEX);
  if (matches) {
    return matches[1];
  }
  return url;
}

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  deserialize(url) {
    return deserializeItemImageUrl(url);
  },
  serialize(url) {
    if (typeof url !== 'string' || url.slice(0, 5) === 'data:') {
      return undefined;
    }
    return url;
  }
});